<template>
  <bk-page 
    class="reserveActionPage" 
    pageType="navPage" 
    :navBarInfo="navBarInfo" 
    @close="close"
  >	
		<template v-if="formData.id && formData.finished">
			<bk-view v-if="showPage==='success'" class="view-success-box">
				<bk-view class="view-image"></bk-view>
				<bk-lang class="view-text" v-if="showSuccess_langCode" :code="showSuccess_langCode"></bk-lang>
				<bk-view class="view-date-main">
					<bk-date :date="formData?.updateDate?.showValue" showHm :curShop="formData"></bk-date>
				</bk-view>
			</bk-view>
			<bk-view v-else class="view-def-box">
				<bk-image v-if="showImageUrl" :src="showImageUrl" />
				<div class="view-desc-main" v-if="showDescText" v-html="showDescText"></div>
				<bk-view v-if="showAction" class="view-btn-list">
					<bk-button langCode="global_button_yes"  @click="handleItemAction('yes')"></bk-button>
					<!-- <bk-button langCode="global_button_no" type="line" @click="handleItemAction('no')"></bk-button> -->
				</bk-view>
			</bk-view>
		</template>

		<breachPenaltyConfirm 
			:show="showPage==='breachPenaltyConfirm'"
			:reserveInfo="formData"
			:curRows="{ status: 3 }"
			@close="setShowPage()"	
			@confirm="handleBreachPenaltyConfirm"
		/>

  </bk-page>
</template>

<script>
	import { reserveReq } from '@/reqService';
	import { baseReq } from '../../reqService';
	import dayjs from 'dayjs';
	import breachPenaltyConfirm from '@/pages/appointments/subPages/appointmentDetail/breachPenaltyConfirm/breachPenaltyConfirm.vue'

	export default {
		name:'reserveAction',
		components:{ breachPenaltyConfirm },
		data (){
			return {
				showPage:'',
				query: this.$route.query,
				formData:{},
				systemInfo:{},
				serviceTime:null,
			};
		},
		computed:{
			navBarInfo (){
				let res = {
					confirm:'reserveAction_confirm_title',
					reschedule:'reserveAction_reschedule_title',
					cancel:'reserveAction_cancel_title',
				};

				return {
					backFlag: false,
					title: !this.showAction || this.showPage ==='success' ? '' : this.$bk_lang[res[this.query?.action]] || ''
				};
			},
			showDescText (){
				let res = {
					confirm:'reserveAction_confirm_desc',
					reschedule:'reserveAction_reschedule_desc',
					cancel:'reserveAction_cancel_desc',
				};

				if(!this.showAction){
					res = {
						confirm:'reserveAction_confirm_msg',
						reschedule:'reserveAction_rescheduling_msg',
						cancel:'reserveAction_cancel_msg',
					};
				}

				return this.$bk_lang[res[this.query?.action]];
			},
			showImageUrl (){
				let res = {
					confirm:'Def_Icon_ReserveAction_Confirm.png',
					reschedule:'Def_Icon_ReserveAction_Reschedule.png',
					cancel:'Def_Icon_ReserveAction_Cancel.png',
				};

				if(!this.showAction){
					return this.$bk_getImageUrl('Def_Icon_ReserveAction_Error.png');
				}

				return this.$bk_getImageUrl(res[this.query?.action]);
			},
			showSuccess_langCode (){
				let res = {
					confirm:'reserveAction_confirm_success',
					reschedule:'reserveAction_reschedule_success',
					cancel:'reserveAction_cancel_success',
				};
				return res[this.query?.action];
			},
			isCorrespondingParameterEnabled(){
				const { MASE313=[] } = this.systemInfo;
				const { action } = this.query;
				let res = false

				if(['confirm'].includes(action)){
					res =  MASE313?.includes('0')
				}

				if(['reschedule'].includes(action)){
					res = MASE313?.includes('1')
				}

				if(['cancel'].includes(action)){
					res = MASE313?.includes('2')
				}

				return res;
			},
			showAction (){
				const { systemInfo, query, formData } = this;
			
				if(['reschedule', 'cancel'].includes(query.action) && this.$bk_resvDepositPay(formData)){
					return false;
				}

				// if(['reschedule'].includes(query.action) && this.$bk_resvStartPayment(formData)){
				// 	return false;
				// }
			
				if(!this.isCorrespondingParameterEnabled || ![0, 1].includes(formData.status)){
					return false;
				}
				
				if(query.action==='confirm'){
					return !formData.userConfirmed;
				}
				
				if(query.action==='reschedule'){
					let diffTime = dayjs(formData.startDateTime?.showValue).valueOf() - this.serviceTime;
					return this.serviceTime && (diffTime > (systemInfo['MASE262'] * 3600000));
				}

				if(query.action==='cancel'){
					let diffTime = dayjs(formData.startDateTime?.showValue).valueOf() - this.serviceTime;
					return this.serviceTime && (diffTime > (systemInfo['MASE019'] * 3600000));
				}

				return true;
			}
		},
		mounted (){
			let token = this.$bk_getAccessToken();
		
			if (this.$bk_isNull(token)) {
				let that = this;
				window.viewCallback = function () {
					that.initData();
				};
				return;
			}
			this.initData();
		},
		methods:{
			close (){
				const { path } = this.$route;
				let { compId } = this.formData;

				if(path.indexOf('/reserveAction') != -1){
					this.$bk_goHome({ compId });
					return false;
				}
				this.$emit('close');
			},
			async initData (){
				const { language } = this.query;
				if(language){
					await this.$bk_setLanguage(language)
				}
				this.reloadData()
			},
			async reloadData(){
				let { reserveId } = this.query;

				if(reserveId){
					await this.requestGetResDetailById();

					await this.requestGetReserveLinkToken();
					
					await this.requestGetServiceDate();

					this.formData.finished = true;
				}
			},
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			async requestGetResDetailById (){
				let { reserveId } = this.query;
				let res = await reserveReq.requestGetResDetailById(this, reserveId);  
				this.formData = res;
				this.requestSystemParamsByCodes();
			},
			async requestGetReserveLinkToken (){
				const { id, userConfirmed, status } = this.formData;
				const { linkToken } = this.query;

				if(linkToken){
					let res = await reserveReq.requestGetReserveLinkToken(this, { reserveId: id, linkToken});	

					if(res?.linkToken){

						if(res.contentCode==='userConfirm' && userConfirmed===1){
							this.query.action = 'confirm';
						}

						if(res.contentCode==='cancel_c' && status==3){
							this.query.action = 'cancel';
						}

						if(res.contentCode==='update'){
							this.query.action = 'reschedule';
						}

						this.setShowPage('success');
					}
				}
			},
			async requestSystemParamsByCodes (){
				const { custId, compId } = this.formData;
				let params = {
					custId, compId,
					paramCodes:[
						'MASE019', // 提前取消预约的时间
						'MASE262', // 预约改期所需提前的时间
						'MASE313', // 允许客户管理其预约
					]
				};
				let res = await baseReq.requestGetSystemParamsByCodes(this, params);
				this.systemInfo = res.systemInfo;
			},
			async requestGetServiceDate (){
				const { compId, custId } = this.formData;	
				let res = await baseReq.requestGetServiceDate(this, { compId, custId });
				this.serviceTime = dayjs(res.dateTime?.showValue).valueOf();
			},
			async handleItemAction (key){
				let { action, reserveId, linkToken } = this.query;
				const { compId, custId } = this.formData;

				if(key==='yes'){

					if(action==='cancel'){
						let x = this.$bk_resvPreAuthPay(this.formData) && this.$bk_resvDepositPaySuccess(this.formData);
						if(x){
							let resPenalty = await reserveReq.requestPenaltyInfo(this, { ...this.formData, status:3 });
							// 触发了扣款规则
							if(resPenalty?.isPenalty==1){
								this.setShowPage('breachPenaltyConfirm');
								return true;
							}
						}
						await reserveReq.requsetPostChangeCalendarStatus(this, { id: reserveId, status: 3, linkToken, contentCode:'cancel_c'});
						this.reloadData();
						return false;
					}

					if(action==='confirm'){
						await reserveReq.requestReserveUserConfirm(this, { id: reserveId, userConfirmed: 1, linkToken, contentCode:'userConfirm' });
						this.reloadData();
						return false; 
					}

					if(action==='reschedule'){
						window.showReserve({ 
							resShopInfo:{ id: compId, custId },
							defReserveInfo: { reserveId, bizScene:'reschedule', linkToken, contentCode:'update' },
						});
						return false;
					}

					return false;
				}

				if(key==='no'){
					this.close();
					return false;
				}
			},
			async handleBreachPenaltyConfirm (){
				let { reserveId, linkToken } = this.query;
				this.setShowPage();
				let params = { 
					id: reserveId,
					linkToken, 
					contentCode:'cancel_c',
					status:3, 
					reserveCharge:{ payChargeAction: 1 } 
				};
				await reserveReq.requsetPostChangeCalendarStatus(this, params);
				this.reloadData();
			},	
		}
	};
</script>

<style lang="less">
@import './reserveAction.less';
</style>